module.exports = __webpack_public_path__ + "img/honorariumlogin5.6bbe4c70.png";